import { Button, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import AlertNew from '../../commons/dialogs/AlertNew';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Monitorizare from './Monitorizare';
import PontajTabel from './PontajTabel';


export default class PontajColectivNew extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            openMonitorizare: false,
            alertView: false,
            foaieColectiva: false
        }
    }

    ls = new LocalStorage().GetUserData()

    componentDidMount() {
        // this.access()
    }

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }





    render() {
        return (
            <div>
                <CustomAppBar history={this.props.history} title='' />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />
                <Grid style={{ maxWidth: 1300, margin: 'auto', marginBottom: 40 }} container >
                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                        <Grid container>
                            <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                                <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.dictionary.pontaje.resurseUmane} </h1>
                            </Grid>


                            {(this.ls.InfoUser.IsAdmin === 1 ? true : (this.ls.InfoUser.EsteSef === 1 ? true : false)) &&

                                <Grid style={{ paddingTop: 80 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <Button
                                        style={{ width: '90%' }}

                                        className={'add-button-blue'} onClick={() => { this.setState({ openMonitorizare: true }) }}  >

                                        {this.dictionary.pontaje.monitorizareLive}
                                    </Button>

                                </Grid>
                            }

                            {(this.ls.InfoUser.IsAdmin === 1 ? true : (this.ls.InfoUser.EsteSef === 1 ? true : false)) &&

                                <Grid style={{ paddingTop: 80 }} item xs={2} sm={2} md={2} lg={2} xl={2}>
                                    <Button
                                        style={{ width: '90%' }}

                                        className={'add-button-blue'} onClick={() => { this.setState({ foaieColectiva: this.state.foaieColectiva ? false : true }) }}  >

                                        {this.state.foaieColectiva ? this.dictionary.pontaje.inapoiLaPontaj : this.dictionary.pontaje.foaieColectiva}
                                    </Button>

                                </Grid>
                            }

                        </Grid>

                    </Grid>

                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                        <PontajTabel
                            history={this.props.history}
                            foaieColectiva={this.state.foaieColectiva}
                        />
                    </Grid>


                </Grid>

                {this.state.openMonitorizare &&

                    <Monitorizare
                        open={this.state.openMonitorizare}
                        dialogClose={() => { this.setState({ openMonitorizare: false }) }}

                    />
                }

            </div>
        );
    }
}